import React, { useEffect, useState } from "react";
import PickUpInfo from "./BookModule.module.css";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../labels";
import { Link, useNavigate } from "react-router-dom";
// import moment from "moment";
export default function PickUpDetails(props) {
  const moment = require("moment-timezone");
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let user_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      user_type = user.user_type;
    }
  } else {
    console.log("User Id not available in session storage");
  }

  const navigate = useNavigate();

  let page = R_PER_PAGE;
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  // total table data  with pages
  const totalPages = Math.ceil(props?.PicUpItem?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  let currentData = props?.PicUpItem?.slice(start, end);
  const handlePickUpDetails = () => {
    navigate(`/AddNewCourierDetails`, {
      state: { purchase_id: props.idPur, labelStatus: 0 },
    });
  };
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = props?.PicUpItem?.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        // console.log("zxcxzc", "sortedList", aValue == bValue, aValue, bValue);
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    currentData = sortedList;
    setSortColumn(sortKey);
  };

  return (
    <div className="row mx-0 mt-3">
      <div className="col-xl-12 col-lg-12 col-md-12 col-12 px-0">
        <fieldset className={PickUpInfo.PickUpInfoContainer}>
          <legend className="w-auto mb-0">Pickup Details</legend>
          {(user_type === 1 || user_type === 3 || user_type === 4) &&
            (props?.PicUpItem?.length === 0 ||
              (props?.bookPur?.length > 0 &&
                props?.bookPur?.some((er) => er.delivery_status !== 2))) && (
              <div className="col-md-12 col-12 ListBtn px-0 mb-3">
                <ul class="List-Button">
                  <li class="ListBtnItems">
                    {!props.disableStatus && (
                      <Link
                        to="javascript:void(0)"
                        onClick={handlePickUpDetails}
                        className="primaryButton text-center"
                        variant="primary"
                      >
                        Add New Pickup Details
                      </Link>
                    )}
                  </li>
                </ul>
              </div>
            )}
          <div className="row mx-0">
            <div
              className={`col-md-12 ${PickUpInfo.table_responsive_padding} table-responsive tableMinHeight  px-0`}
            >
              <table className="table" id="tableListHeader">
                <thead>
                  <tr>
                    <th id="th" className={PickUpInfo.tableThPadding}>
                      <span className="textHead_th">Pickup ID</span>
                    </th>
                    <th id="th" className={PickUpInfo.tableThPadding}>
                      <span className="textHead_th">Pickup Date & Time</span>
                      {user_type === 1 && (
                        <span
                          onClick={(e) => handleSort(e, "created_dt")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export
                        </span>
                      )}
                    </th>
                    <th id="th" className={PickUpInfo.tableThPadding}>
                      <span className="textHead_th">Book Names</span>
                    </th>
                    <th id="th" className={PickUpInfo.tableThPadding}>
                      <span className="textHead_th">Pickup Status</span>
                      {user_type === 1 && (
                        <span
                          onClick={(e) => handleSort(e, "delivery_status")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export
                        </span>
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData?.length === 0 ? (
                    <tr>
                      <td colspan="15" style={{ textAlign: "center" }}>
                        No records to display
                      </td>
                    </tr>
                  ) : (
                    currentData?.map((kl, ind) => (
                      <tr key={ind}>
                        <td id="td">{kl.tracking_id ? kl.tracking_id : "_"}</td>

                        <td id="td">
                          {kl.created_dt
                            ? moment(kl.created_dt).utc().format("DD/MM/YYYY hh:mm:ss a")
                            : "_"}
                        </td>
                        <td id="td">
                          <span
                            title={kl.bookTitles}
                            className={PickUpInfo.ellipsisText}
                          >
                            {kl.bookTitles ? kl.bookTitles : "_"}
                          </span>
                        </td>

                        <td id="td">
                          {kl.delivery_status ? kl.delivery_status : "_"}
                          {/* {kl.delivery_status == 2 && (
                            <span
                              className={`${PickUpInfo.deliveryStatus} ms-0  ${PickUpInfo.deliveryStatusGreen}`}
                            >
                              Delivered
                            </span>
                          )}
                          {kl.delivery_status == 1 && (
                            <span
                              className={`${PickUpInfo.deliveryStatus} ms-0  ${PickUpInfo.deliveryStatusYellow}`}
                            >
                              Shipping in Progress
                            </span>
                          )}
                          {kl.delivery_status == 0 && (
                            <span
                              className={`${PickUpInfo.deliveryStatus} ms-0  ${PickUpInfo.deliveryStatusPink}`}
                            >
                              Pickup Pending
                            </span>
                          )} */}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row mt-2">
            <Pagination
              rowsPerPage={rowsPerPage}
              handlePageCount={handlePageCount}
              startPage={
                currentData && currentData?.length > 0
                  ? currentPage * rowsPerPage + 1 - rowsPerPage
                  : 0
              }
              endPage={
                currentData && currentData?.length > 0
                  ? currentData?.length < currentPage * rowsPerPage
                    ? currentData?.length
                    : currentPage * rowsPerPage
                  : 0
              }
              totalRecords={
                currentData && currentData?.length > 0 ? currentData?.length : 0
              }
              handlePrev={(e) => handlePrev(currentPage - 1)}
              currentPrevPage={currentPage === 1}
              prevButton={`${PickUpInfo.prev_buttonViewAllbook} ${PickUpInfo.materialIconsRightAndLeft} me-2`}
              handleNext={() => handleNext(currentPage + 1)}
              currentNextPage={totalPages == 0 || currentPage === totalPages}
            />
          </div>
        </fieldset>
      </div>
    </div>
  );
}
